module.exports = __webpack_public_path__ + "img/footer-cyber-security-27001.5f56e0b3.png";